import * as React from 'react';

import type { DialogProps } from '@mui/material';
import { Dialog } from '@mui/material';

export interface DialogRootProps {
  /** 대화상자 내부에 표시할 구성 요소다. */
  children?: React.ReactNode;
  /** 대화상자의 표시 여부다. */
  open: boolean;
  /** backdrop 또는 Escape로 닫기를 요청할 때 호출한다. */
  onClose?: DialogProps['onClose'];
  /** 대화상자의 최대 너비다. 기본값은 기존과 같은 `lg`다. */
  maxWidth?: DialogProps['maxWidth'];
  /** 최대 너비까지 대화상자를 확장할지 여부다. */
  fullWidth?: DialogProps['fullWidth'];
  /** Escape 키로 닫기를 막을지 여부다. */
  disableEscapeKeyDown?: DialogProps['disableEscapeKeyDown'];
  /** 대화상자 Paper에 전달할 속성이다. 크기와 overflow 보정에 사용한다. */
  PaperProps?: DialogProps['PaperProps'];
  /** Dialog container를 포함한 추가 스타일이다. */
  sx?: DialogProps['sx'];
}

/**
 * 공통 paper-scroll 동작을 유지하며 대화상자 루트를 렌더링한다.
 *
 * TODO: #2079 LookoModal 스토리북 옮기고, 사용법 추가.
 *
 * @param props 대화상자 표시·닫기·크기·스타일 속성
 * @returns 공통 스크롤 동작이 적용된 MUI 대화상자
 */
export default function DialogRoot({
  children,
  open,
  onClose,
  maxWidth = 'lg',
  fullWidth,
  disableEscapeKeyDown,
  PaperProps,
  sx,
}: DialogRootProps) {
  return (
    <Dialog
      open={open}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      disableEscapeKeyDown={disableEscapeKeyDown}
      PaperProps={PaperProps}
      sx={sx}
      keepMounted={false}
      scroll="paper"
      onClose={onClose}
      onWheel={e => e.stopPropagation()}
    >
      {children}
    </Dialog>
  );
}
